function checkPermission(code) {
  console.log("check permission");
  let auths = getJVxeAuths('');
  console.log(auths);
  return auths.has(code) && auths.get(code).isAuth;
}

function getPrefix(prefix) {
  if (prefix && !prefix.endsWith(':')) {
    return prefix + ':';
  }
  return prefix;
}

function getJVxeAuths(prefix) {
  let permissionStore = JSON.parse(window.localStorage.getItem('permCode'));
  prefix = getPrefix(prefix);
  let { auth, allAuth } = permissionStore;
  let authsMap = new Map();
  // 将所有vxe用到的权限取出来
  for (let auth of allAuth) {
    if (auth.status == '1' && (auth.action || '').startsWith(prefix)) {
      authsMap.set(auth.action, { ...auth, isAuth: false });
    }
  }
  // 设置是否已授权
  for (let a of auth) {
    let getAuth = authsMap.get(a.action);
    if (getAuth != null) {
      getAuth.isAuth = true;
    }
  }
  return authsMap;
}



export default checkPermission
